module.exports = __webpack_public_path__ + "static/illustration_-e01172d4afeadef1df7c5381eb62aab3.png";